export type ShipmentJobStatus = "PENDING" | "RUNNING" | "SUCCEEDED" | "FAILED";

export type ShipmentJobKind = "CREATE_SHIPMENT" | "EDIT_SHIPMENT";

export type ShipmentJobStage =
  | "QUEUED"
  | "VALIDATING_PALLETS"
  | "AGGREGATING_PRODUCTS"
  | "UPDATING_AA_PO"
  | "GENERATING_INVOICES"
  | "PERSISTING_SHIPMENT"
  | "DISPATCHING_PALLETS"
  | "FINALISING_METRICS"
  | "DONE";

export interface ShipmentJobProgress {
  stage: ShipmentJobStage;
  percent: number;
  message?: string;
}

export interface ShipmentJobError {
  code: string;
  message: string;
}

export interface EnqueueShipmentJobResponse {
  jobId: string;
  status: ShipmentJobStatus;
}

export interface ShipmentJobRecord {
  id: string;
  kind: ShipmentJobKind;
  status: ShipmentJobStatus;
  progress: ShipmentJobProgress;
  resultRef?: { shipmentId: string };
  error?: ShipmentJobError;
  submittedByEmail: string;
  createdAt?: string;
  startedAt?: string;
  finishedAt?: string;
  updatedAt?: string;
}

export const STAGE_LABELS: Record<ShipmentJobStage, string> = {
  QUEUED: "Queued",
  VALIDATING_PALLETS: "Validating pallets",
  AGGREGATING_PRODUCTS: "Aggregating products",
  UPDATING_AA_PO: "Updating Active Ants purchase order",
  GENERATING_INVOICES: "Generating commercial invoices",
  PERSISTING_SHIPMENT: "Saving shipment",
  DISPATCHING_PALLETS: "Dispatching pallets",
  FINALISING_METRICS: "Finalising metrics",
  DONE: "Done"
};
